/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
  FxGamesLibWebRpcContractsResponse,
  FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
    FxGamesLibWebRpcContractsResponseFromJSON,
    FxGamesLibWebRpcContractsResponseToJSON,
    FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsFromJSON,
    FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSON,
} from '../models/index';

export interface FxIdWebFeaturesPushTokensSavePushTokenEndpointRequest {
    fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs: FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs;
}

/**
 * 
 */
export class PushTokensApi extends runtime.BaseAPI {

    /**
     * **MUTATES:** `pushtoken`    Saves push token  
     */
    async fxIdWebFeaturesPushTokensSavePushTokenEndpointRaw(requestParameters: FxIdWebFeaturesPushTokensSavePushTokenEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxGamesLibWebRpcContractsResponse>> {
        if (requestParameters['fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs'] == null) {
            throw new runtime.RequiredError(
                'fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs',
                'Required parameter "fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs" was null or undefined when calling fxIdWebFeaturesPushTokensSavePushTokenEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/push_tokens/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSON(requestParameters['fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `pushtoken`    Saves push token  
     */
    async fxIdWebFeaturesPushTokensSavePushTokenEndpoint(fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs: FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxGamesLibWebRpcContractsResponse> {
        const response = await this.fxIdWebFeaturesPushTokensSavePushTokenEndpointRaw({ fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs: fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs }, initOverrides);
        return await response.value();
    }

}
